import { useQueryClient } from '@tanstack/react-query';
import { FormProvider, useForm } from 'react-hook-form';
import { createGlobalStyle } from 'styled-components';
import { NewProjectContext } from '@contexts/NewProject.context';
import { DEFAULT_MODEL_OPTION } from '@config/videoDetectionModelConfig';
import VideoProjectWizard from '@routes/userRoutes/projects/newProject/components/video/VideoProjectWizard';

/**
 * Development only (registered when import.meta.env.DEV): the new-video-project wizard without a backend.
 * Pick any local MP4 to walk through Select → Configure; "Upload & analyse" would call the real API.
 */

const HideCookieBanner = createGlobalStyle`
	#CybotCookiebotDialog, #CybotCookiebotDialogBodyUnderlay { display: none !important; }
`;

const VideoWizardDevPage = () => {
	const queryClient = useQueryClient();
	// the tags select reads the user's tags; fill the cache so no request goes out
	if (!queryClient.getQueryData(['user_tags']))
		queryClient.setQueryData(['user_tags'], { tags: ['reindeer', '2026'], allowCreate: true });
	const methods = useForm({
		defaultValues: {
			projectName: new URLSearchParams(window.location.search).get('name') || '',
			projectDescription: '',
			projectTags: [],
			modelOption: DEFAULT_MODEL_OPTION,
		},
	});
	return (
		<FormProvider {...methods}>
			<HideCookieBanner />
			<NewProjectContext.Provider
				value={{ mode: 'video', setMode: () => window.history.back() }}
			>
				<VideoProjectWizard />
			</NewProjectContext.Provider>
		</FormProvider>
	);
};

export default VideoWizardDevPage;
